package com.ijoin.data.model

import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

@Serializable
data class CancelSlotsRequest(
    val slotIds: List<Long>,
    val reason: String? = null,
)

@Serializable
data class CreateTimeOffRequest(
    val startDate: LocalDate,
    val endDate: LocalDate,
    val type: TimeOffType = TimeOffType.OTHER,
    val reason: String? = null,
)

@Serializable
enum class TimeOffType {
    VACATION,
    SICK_LEAVE,
    BUSINESS_TRIP,
    OTHER,
}
